import {useState} from 'react';
import {Button, Indicator} from '@mantine/core';
import {FiFilter} from 'react-icons/fi';
import {I18n} from '@aws-amplify/core';
import {FilterDrawer} from '../drawers/FilterDrawer';
import {useUsageEventsFilter} from '../hooks/useUsageEventsFilter';

export const FilterRecordsButton = () => {
    const [opened, setOpened] = useState(false);
    const {activeCount} = useUsageEventsFilter();

    return (
        <>
            <Indicator label={activeCount} size={16} disabled={activeCount === 0}>
                <Button
                    variant='outline'
                    leftSection={<FiFilter size={16}/>}
                    onClick={() => setOpened(true)}
                    data-testid='usage-events-filter-button'
                >
                    {I18n.get('Filter')}
                </Button>
            </Indicator>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
